<template>
  <b-container>
    <b-row>
      <b-col>
        <h5 class="package-title" v-translate>
          Date pasageri
        </h5>
      </b-col>
    </b-row>
    <template v-if="booking">
      <b-row v-for="(pax, i) in booking.pax" :key="pax.id">
        <b-col>
          <hr />
          <h6 class="booking-details-title">{{ pax.title}} {{ pax.fname }} {{ pax.lname }} ({{ pax.ageGroup }} {{ pax.age }})</h6>
          <b-card>
            <b-row>
              <b-col sm="3">
                <b-form-group
                  :label="$gettext('Gender')"
                  label-class="font-weight-bold my-0 py-0 chr-label"
                  label-for="gender"
                  class="mb-0"
                >
                  <b-form-select
                    id="gender"
                    size="sm"
                    v-model="pax.sex"
                    :options="gender"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled>-- <translate>select</translate> --</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="9">
                <b-form-group
                :label="$gettext('Address')"
                label-class="font-weight-bold my-0 chr-label"
                label-for="address"
                class="mb-0"
                >
                <b-input
                  type="text"
                  name="address"
                  id="address"
                  v-model="pax.address"
                  size="sm" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <b-form-group
                :label="$gettext('Home country')"
                  label-class="font-weight-bold my-0 py-0 chr-label"
                  label-for="country"
                  class="mb-0"
                >
                  <b-form-select
                    id="country"
                    size="sm"
                    v-model="pax.country"
                    :options="isoCountriesOptions"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled>-- <translate>select</translate> --</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group
                  :label="$gettext('Nationality')"
                  label-class="font-weight-bold my-0 py-0 chr-label"
                  label-for="countryName"
                  class="mb-0"
                >
                  <b-form-select
                    id="countryName"
                    size="sm"
                    v-model="pax.nationality"
                    :options="isoCountriesOptions"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled>-- <translate>select</translate> --</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group
                  :label="$gettext('Born in')"
                  label-class="font-weight-bold my-0 py-0 chr-label"
                  label-for="birthCountry"
                  class="mb-0"
                >
                  <b-form-select
                    id="birthCountry"
                    size="sm"
                    v-model="pax.birth_country"
                    :options="isoCountriesOptions"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled>-- <translate>select</translate> --</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group
                  :label="$gettext('Identity document')"
                  label-class="font-weight-bold my-0 py-0 chr-label"
                  label-for="identityDoc"
                  class="mb-0"
                >
                  <b-form-select
                    id="identityDoc"
                    size="sm"
                    v-model="pax.tdoc_type"
                    :options="documentTypes"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled>-- <translate>select</translate> --</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <b-form-group
                :label="$gettext('Document no')"
                label-class="font-weight-bold my-0 chr-label"
                label-for="noDoc"
                class="mb-0"
                >
                <b-input
                  type="text"
                  name="noDoc"
                  id="noDoc"
                  v-model="pax.tdoc_no"
                  size="sm" />
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group
                  :label="$gettext('Issued by')"
                  label-class="font-weight-bold my-0 py-0 chr-label"
                  label-for="emitted"
                  class="mb-0"
                >
                  <b-form-select
                    id="emitted"
                    size="sm"
                    v-model="pax.tdoc_country"
                    :options="isoCountriesOptions"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled>-- <translate>select</translate> --</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group
                  :label="$gettext('Issue date')"
                  label-class="font-weight-bold my-0 py-0 chr-label"
                  class="mb-0"
                >
                  <DatePicker
                    size="sm"
                    v-model="issueDates[i]"
                    lang="en"
                    :today-label="$gettext('today')"
                    :selected-date-label="$gettext('selected date')"
                  ></DatePicker>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group
                  :label="$gettext('Valid to')"
                  label-class="font-weight-bold my-0 py-0 chr-label"
                  class="mb-0"
                >
                  <DatePicker
                    size="sm"
                    v-model="expiryDates[i]"
                    lang="en"
                    :today-label="$gettext('today')"
                    :selected-date-label="$gettext('selected date')"
                  ></DatePicker>
                </b-form-group>
              </b-col>
              <b-col>
                <small class="text-danger" v-translate>*For the field with <b>“Series &amp; No. document”</b>, data entry format is: <b>Identity card</b>: series and number (without spaces) / <b>Passport</b>: passport number</small>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group
                  :label="$gettext('Telephone')"
                  label-class="font-weight-bold my-0 chr-label"
                  label-for="telephone"
                  class="mb-0"
                  >
                  <b-input
                    type="text"
                    name="telephone"
                    id="telephone"
                    v-model="pax.tel"
                    size="sm" />
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group
                  :label="$gettext('Email')"
                  label-class="font-weight-bold my-0 chr-label"
                  label-for="email"
                  class="mb-0"
                  >
                  <b-input
                    type="text"
                    name="email"
                    id="email"
                    v-model="pax.email"
                    size="sm" />
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <small>*<translate>Please fill in a no. phone number and an email address, where tourists can be contacted in due time, in case of emergency situations</translate>.</small>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  :label="$gettext('Passenger details')"
                  label-class="font-weight-bold my-0 chr-label"
                  class="mb-0"
                >
                  <textarea v-model="pax.notes" class="form-control"></textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </template>
    <div class="w-100">
      <b-col><hr></b-col>
      <b-button-group size="sm" class="float-right">
        <b-button
          variant="warning"
          @click="$emit('closeModal')"
        >
          <translate>Close</translate>
        </b-button>
        <b-button
          variant="primary"
          @click="save()"
        >
          <translate>Save</translate>
        </b-button>
      </b-button-group>
  </div>
  </b-container>
</template>

<script>
// TODO: add computed properties for dates, validation, and maybe conditional mask for document no
import moment from 'moment'
import DatePicker from 'b2b-common/components/datepicker'
import { getISOCountries, getBooking, savePax } from 'b2b-common/services/api/booking'
import { documentTypes } from 'b2b-common/utils'

export default {
  name: 'editPassenger',
  components: { DatePicker },
  props: {
    bookingId: {}
  },
  data () {
    return {
      gender: ['M', 'F'],
      documentTypes: documentTypes.map(el => ({ value: el.code, text: el.label })),
      isoCountries: [],
      booking: null,
      issueDates: [],
      expiryDates: []
    }
  },
  computed: {
    isoCountriesOptions () {
      return this.isoCountries.map(el => ({ value: el.ISO3, text: el.name }))
    }
  },
  methods: {
    async save () {
      for (let i = 0; i < this.issueDates.length; i++) {
        this.booking.pax[i].tdoc_issue = this.issueDates[i] ? moment(this.issueDates[i]).format('DD-MM-YYYY') : null
        this.booking.pax[i].tdoc_expiry = this.expiryDates[i] ? moment(this.expiryDates[i]).format('DD-MM-YYYY') : null
      }
      await savePax({ booking: this.booking.id, pax: this.booking.pax })
      this.$emit('closeModal')
    }
  },
  mounted () {
    getISOCountries().then(res => { this.isoCountries = res })
    getBooking({ bookingId: this.bookingId }).then(res => {
      this.booking = res
      this.booking.pax.forEach(p => {
        this.issueDates.push(p.tdoc_issue ? moment(p.tdoc_issue, 'DD-MM-YYYY').toDate() : null)
        this.expiryDates.push(p.tdoc_expiry ? moment(p.tdoc_expiry, 'DD-MM-YYYY').toDate() : null)
      })
    })
  }
}
</script>
